import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { CustomButton, Text } from '../../../../shared/uiComponents';
import { DOWNLOAD_ALERT_TEXT } from '../../../../shared/Helpers/constants';

import { DispatchProperties, useSelector } from '../../../../redux/store';
import { setBtStatuses } from '../../../../redux/State/clientSlice/soapNoteSlice';

interface DownloadAlertContentProps {
	onClose: () => void;
	onDownload: () => void;
}

const DownloadAlertContent = ({ onClose, onDownload }: DownloadAlertContentProps) => {
	const dispatch = useDispatch<DispatchProperties>();
	const navigate = useNavigate();
	const loading = useSelector((state) => state.billing.loading);

	const navigateToPendingBT = useCallback(() => {
		// Set the Pending BT filter (status id "5")
		dispatch(setBtStatuses(['5']));

		// Set tab to DSU Notes (index 1)
		window.localStorage.setItem('tab', '1');

		// Navigate to SOAP Notes
		navigate('/soap-notes');

		onClose();
	}, [dispatch, navigate, onClose]);

	const navigateToDateChange = useCallback(() => {
		// Navigate to dashboard to view flagged sessions
		navigate('/dashboard');

		// Scroll to bottom after navigation to show flagged sessions
		setTimeout(() => {
			window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
		}, 500);

		onClose();
	}, [navigate, onClose]);

	return (
		<div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
			<Text title={DOWNLOAD_ALERT_TEXT} type="psm" fontWeight="regular" className="marginBottom16" />
			<div style={{ display: 'flex', gap: '16px', justifyContent: 'flex-end' }}>
				<CustomButton title="Cancel" onClick={onClose} buttonType="secondaryGray" />
				<CustomButton title="Date Change" onClick={navigateToDateChange} buttonType="secondary" />
				<CustomButton title="Pending BT" onClick={navigateToPendingBT} buttonType="secondary" />
				<CustomButton title="Download" onClick={onDownload} loading={loading} />
			</div>
		</div>
	);
};

export default DownloadAlertContent;
